import '../scss/_homepage.scss';
const initHomepage = () => {
  const root = document.querySelector('.wwh');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  // Content remains visible without JS; only animate sections entering from below.
  if ('IntersectionObserver' in window && !motion.matches) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(({ target, isIntersecting }) => {
        if (!isIntersecting) return;
        observer.unobserve(target);
        if (!motion.matches && target.animate) target.animate([
          { transform: 'translateY(24px)', opacity: 0 },
          { transform: 'translateY(0)', opacity: 1 },
        ], { duration: 500, easing: 'ease-out' });
      });
    }, { threshold: 0.05 });
    root.querySelectorAll('[data-wwh-reveal]').forEach(element => {
      if (element.getBoundingClientRect().top >= window.innerHeight) observer.observe(element);
    });
  }

  const demo = root.querySelector('.wwh-demo');
  const slots = demo.querySelector('.wwh-demo-slots');
  const empty = demo.querySelector('.wwh-demo-empty');
  const status = demo.querySelector('.wwh-demo-status');
  const count = demo.querySelector('[data-demo-count]');
  const reset = demo.querySelector('[data-demo-reset]');
  const selected = new Map();
  const render = (card, pick) => {
    const id = card.dataset.demoCard;
    let chip = slots.querySelector(`[data-chip="${id}"]`);
    const old = selected.get(id);
    card.querySelectorAll('[data-pick]').forEach(button => button.setAttribute('aria-pressed', 'false'));
    if (old === pick) {
      selected.delete(id);
      if (chip) chip.remove();
    } else {
      selected.set(id, pick);
      card.querySelector(`[data-pick="${pick}"]`).setAttribute('aria-pressed', 'true');
      if (!chip) {
        chip = document.createElement('span');
        chip.className = 'wwh-pick-chip';
        chip.dataset.chip = id;
        slots.appendChild(chip);
      }
      chip.textContent = `${card.querySelector('.wwh-demo-player strong').textContent} · ${pick} ${card.querySelector('.wwh-demo-stat strong').textContent}`;
    }
    empty.hidden = selected.size > 0;
    count.textContent = `${selected.size} / 2`;
    reset.hidden = selected.size === 0;
    status.textContent = selected.size === 2
      ? 'Your sample lineup is ready. Head to the board to choose real picks.'
      : selected.size === 1 ? 'One pick in. Choose your second player.' : 'Choose More or Less to try it out.';
    if (chip && chip.isConnected && !motion.matches && chip.animate) {
      chip.getAnimations().forEach(animation => animation.cancel());
      chip.animate([{ opacity: 0, transform: 'translateY(-10px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 250, easing: 'ease-out' });
    }
  };
  demo.querySelectorAll('[data-pick]').forEach(button => {
    button.disabled = false;
    button.addEventListener('click', () => render(button.closest('[data-demo-card]'), button.dataset.pick));
  });
  reset.addEventListener('click', () => {
    selected.clear();
    slots.querySelectorAll('[data-chip]').forEach(chip => chip.remove());
    demo.querySelectorAll('[data-pick]').forEach(button => button.setAttribute('aria-pressed', 'false'));
    empty.hidden = false;
    count.textContent = '0 / 2';
    status.textContent = 'Choose More or Less to try it out.';
    reset.hidden = true;
    demo.querySelector('[data-pick]').focus();
  });
  // Reveal availability before navigating to a collapsed details element.
  root.querySelectorAll('a[href="#wwh-availability"]').forEach(link => {
    link.addEventListener('click', () => { root.querySelector('#wwh-availability').open = true; });
  });
  if (window.location.hash === '#wwh-availability') root.querySelector('#wwh-availability').open = true;
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initHomepage, { once: true });
else initHomepage();
